import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';

import { AuthService } from '../../shared/auth.service';
import { Container } from '../../shared/models';
import { EulaService, PlatformService } from 'src/app/shared/services';
import { TenantEula } from 'src/app/shared/models/tenantEula';
@Component({
  selector: 'eula-page',
  templateUrl: './eula.component.html',
})
export class EulaComponent implements OnInit {

  containers: Container[];
  selectedContainer: Container;

  eulaAccepted: boolean;
  tenantEula: TenantEula;
  isSubmitting: boolean;
  displayErrorMessage: boolean;
  EulaModule: any;

  constructor(
    private _router: Router,
    private _authService: AuthService,
    private _eulaService: EulaService,
    private _platformService: PlatformService,
  ) {
    this.EulaModule = this._platformService.getPlatformModule().Eula;
  }

  ngOnInit(): void {
    this.eulaAccepted = false;
    this.isSubmitting = false;
    this.displayErrorMessage = false;

    this.lookupTenantEula();
  }

  lookupTenantEula(): void {
    this._eulaService.fetch().subscribe(({ data }) => {
      this.tenantEula = data;
    });
  }

  async accept(): Promise<void> {
    this.isSubmitting = true;

    if (!this.eulaAccepted) {
      this.displayErrorMessage = true;
      this.isSubmitting = false;
      return;
    }

    try {
      await this.EulaModule.updateEula(1);
      this.refreshAndNavigateOut();
    } catch (err) {
      console.log('error updating EULA');
      console.log(err);
      this.isSubmitting = false;
    }
  }

  refreshAndNavigateOut(retries: number = 5): void {
    if (this._authService.isEulaAccepted() || retries === 0) {
      this.isSubmitting = false;
      this._router.navigate(['/']);
    } else {
      this._authService.refreshSession(() => {
        this.refreshAndNavigateOut(retries - 1);
      });
    }
  }

}
